export const LOCAL_STORAGE_SELECTED_TENANTS_KEY: string = 'selected_tenants';
